/** Every monster by kind (spec 02 §4): one entry point for the game view and the line-up. */

import type { Material } from 'three';
import type { MonsterKind } from '../../levels/types';
import type { Palette } from '../palette';
import { buildInvader, buildMonsta, buildPulpul } from './monstersFly';
import { buildBanebou, buildDrunk, buildHidegons, buildMighta, buildZenChan } from './monstersWalk';
import type { Puppet } from './puppet';

export { buildSkelMonsta } from './monstersFly';

const BUILDERS: Record<MonsterKind, (p: Palette, angry: boolean, m: Material) => Puppet> = {
  zenChan: buildZenChan,
  mighta: buildMighta,
  monsta: buildMonsta,
  pulpul: buildPulpul,
  banebou: buildBanebou,
  hidegons: buildHidegons,
  invader: buildInvader,
  drunk: buildDrunk,
};

export function buildMonster(kind: MonsterKind, angry: boolean, p: Palette, material: Material): Puppet {
  return BUILDERS[kind](p, angry, material);
}

/** Face left (-1) or right (1); kept for callers that hold a monster by kind. */
export function face(pup: Puppet, dir: 1 | -1): void {
  pup.face(dir);
}
